// extracted by mini-css-extract-plugin
export default {"tagListContainer":"tagList_tagListContainer__hBSJ0","container":"tagList_container__2DRNM","actionButtons":"tagList_actionButtons__rxyiZ"};